import type { StatementGrouping } from "../change-order/current-statement";

// 데모 화면 경로 한 벌 — 고객 링크(/s·/c) 대신 토큰 없는 고정 경로를 쓴다.
export const DEMO_PATH = {
  home: "/demo",
  quote: "/demo/quote",
  project: "/demo/project",
  statement: "/demo/statement",
} as const;

export const DEMO_TOKEN = "demo";

export const demoStatementPath = (grouping: StatementGrouping): string =>
  grouping === "space" ? `${DEMO_PATH.statement}?by=space` : DEMO_PATH.statement;

export const DEMO_NO_SAVE_MESSAGE = "데모에서는 저장되지 않습니다";
